import React from 'react'
import { Route, HashRouter } from 'react-router-dom'
import { routes } from './index'

const RouterMaster = () => {
    return (
        <HashRouter>
            {
                routes.map((item: any, index: number)=>{
                    return (
                        <Route  exact={item.exact} path={item.path} component={item.component} key={index}></Route>
                    )
                })
            }
        </HashRouter>
    )
}

export default RouterMaster